module.exports = __webpack_public_path__ + "img/noticia3.84159bd2.png";